import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { apiErrorMessage } from "@/lib/api";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(apiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="login-page">
      <h1 className="font-serif text-3xl font-bold text-[#10243A] mb-8">Вход</h1>
      <form onSubmit={submit} className="space-y-4">
        <Input type="email" required placeholder="Имейл" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
        <Input type="password" required placeholder="Парола" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
        {error && <p className="text-sm text-[#C34747]" data-testid="login-error">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full bg-[#10243A] hover:bg-[#C47A35] transition-colors" data-testid="login-submit-btn">
          {loading ? "Влизане..." : "Влез"}
        </Button>
      </form>
    </div>
  );
}
